/* Milano toppers guide — progressive enhancement only.
   One job: a staggered reveal of cards as they enter the viewport
   (same pattern as milano-density-guide.js). Nothing on /pages/toppers
   depends on this file — every section is fully readable, linkable and
   crawlable with JavaScript off.
   Idempotent: several sections include the tag; every init is guarded.
   Theme-editor safe via shopify:section:load. */
(function () {
  'use strict';

  if (window.MilanoToppersGuide) return;
  window.MilanoToppersGuide = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var items = (root || document).querySelectorAll('[data-mtg-reveal]:not(.is-revealed)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    Array.prototype.forEach.call(items, function (el) {
      var index = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--mtg-delay', Math.min(Math.max(index, 0) * 55, 330) + 'ms');
      observer.observe(el);
    });
  }

  /* Enables the pre-reveal hidden state only when JS is actually running. */
  document.documentElement.classList.add('mtg-js');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveals(document);
    });
  } else {
    initReveals(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReveals(event.target);
  });
})();
